import { useState, useEffect } from 'react';
import DockUtils from './DockUtils';
import logger from '../../utils/logger';

/**
 * Dock相关的自定义Hooks
 */
export const useDockData = () => {
  const [recentApps, setRecentApps] = useState([]);
  const [mostUsedApps, setMostUsedApps] = useState([]);

  // 更新最常用网站列表
  const updateMostUsedApps = () => {
    console.log('[DockHooks] 更新最常用网站');
    const mostUsed = DockUtils.getMostUsedWebsites(3);
    console.log('[DockHooks] 获取到最常用网站', mostUsed);
    setMostUsedApps(mostUsed);
  };

  // 更新最近使用应用列表
  const updateRecentApps = () => {
    const recent = DockUtils.getRecentApps();
    setRecentApps(recent);
  };

  // 初始化数据
  useEffect(() => {
    console.log('[DockHooks] useEffect 开始执行，准备注册事件监听器');
    updateRecentApps();
    updateMostUsedApps();
  }, []);

  // 监听事件
  useEffect(() => {
    console.log('[DockHooks] useEffect 开始执行，准备注册事件监听器');
    
    // 监听应用添加到最近使用的事件
    const handleAddRecentApp = (event) => {
      const appData = event.detail;
      if (!appData || !appData.id) return;
      
      setRecentApps(prev => {
        // 如果已存在相同应用，先移除
        const filtered = prev.filter(app => app.id !== appData.id);
        // 添加到开头并限制数量
        return [appData, ...filtered].slice(0, 3);
      });
    };
    
    // 监听grid-app-delete事件
    const handleGridAppDelete = (event) => {
      if (!event.detail || !event.detail.id) return;
      
      const appId = event.detail.id;
      
      // 从最近使用区域中删除相同ID的应用
      setRecentApps(prev => {
        const newApps = prev.filter(app => app && app.id !== appId);
        if (newApps.length !== prev.length) {
          DockUtils.removeFromRecentApps(appId);
        }
        return newApps;
      });
      
      // 更新最常用网站列表
      updateMostUsedApps();
    };

    // 监听网站点击事件
    const handleWebsiteClick = (event) => {
      console.log('[DockHooks] 收到websiteClick事件', event.detail);
      
      // 处理两种数据结构：event.detail.website 或 event.detail 直接是网站数据
      let website = null;
      if (event.detail && event.detail.website) {
        website = event.detail.website;
      } else if (event.detail && event.detail.url) {
        website = event.detail;
      }
      
      if (website) {
        const url = website.url || website.link;
        if (url) {
          console.log('[DockHooks] 处理网站点击', { url, website });
          DockUtils.recordWebsiteClick(url, website);
          updateMostUsedApps();
        }
      }
    };

    // 监听最常用网站更新事件
    const handleUpdateMostUsed = () => {
      updateMostUsedApps();
    };

    // 监听图标加载错误事件
    const handleIconLoadError = (event) => {
      if (event.detail && event.detail.appId) {
        const appId = event.detail.appId;
        
        // 更新最近使用应用列表
        setRecentApps(prevApps => 
          prevApps.map(app => 
            DockUtils.handleIconLoadError(appId, app)
          )
        );
        
        // 更新最常用网站列表
        setMostUsedApps(prevApps => 
          prevApps.map(app => 
            DockUtils.handleIconLoadError(appId, app)
          )
        );
      }
    };

    // 注册事件监听器
    console.log('[DockHooks] 注册事件监听器');
    window.addEventListener('dockAddRecentApp', handleAddRecentApp);
    window.addEventListener('grid-app-delete', handleGridAppDelete);
    window.addEventListener('websiteClick', handleWebsiteClick);
    window.addEventListener('dockUpdateMostUsed', handleUpdateMostUsed);
    window.addEventListener('iconLoadError', handleIconLoadError);
    
    return () => {
      window.removeEventListener('dockAddRecentApp', handleAddRecentApp);
      window.removeEventListener('grid-app-delete', handleGridAppDelete);
      window.removeEventListener('websiteClick', handleWebsiteClick);
      window.removeEventListener('dockUpdateMostUsed', handleUpdateMostUsed);
      window.removeEventListener('iconLoadError', handleIconLoadError);
    };
  }, []);

  return {
    recentApps,
    mostUsedApps,
    updateRecentApps,
    updateMostUsedApps
  };
};

/**
 * 定期清理Hook
 */
export const useDockCleanup = () => {
  useEffect(() => {
    // 定期清理过期的点击记录
    const cleanupInterval = setInterval(() => {
      DockUtils.cleanupExpiredRecords(30); // 保留30天的记录
    }, 24 * 60 * 60 * 1000); // 每24小时清理一次

    return () => {
      clearInterval(cleanupInterval);
    };
  }, []);
};
